import type { TupleToUnion } from 'type-fest'

export const pageBackgroundNames = ['default'] as const

export type PageBackground = TupleToUnion<typeof pageBackgroundNames>

export const pageBackgroundMap: Record<PageBackground, string> = {
  default: 'bg-qf-main',
}
